import { PAGINATION_TAKE } from "./constants";

export function reducer(state, action) {
  switch (action.type) {
    case "loaded_worksite": {
      return {
        ...state,
        loading_worksite: false,
        worksite: action.worksite || {},
      };
    }
    case "loaded_tasks": {
      return {
        ...state,
        loading_tasks: false,
        tasks: action.tasks || [],
        totalPages: action.totalPages,
      };
    }
    case "loading_error": {
      return {
        ...state,
        loading_tasks: false,
        loading_worksite: false,
        error_load: true,
      };
    }
    case "change_page": {
      return {
        ...state,
        paginationSkip: action.page * PAGINATION_TAKE,
      };
    }

    case "loading": {
      return {
        ...state,
        ["loading_" + action.entity]: true,
      };
    }
    case "setfilters": {
      return {
        ...state,
        paginationSkip: 0,
        filters: action.filters,
      };
    }
    case "open_task_modal": {
      if (action.history) {
        state.history.push(
          `/${state.country.code}/worksites/${state.worksite.id}/tasks/list`
        );
      }
      return {
        ...state,
        taskCreateModalOpen: action.open,
        templateId: action.templateId,
        surveyId: action.surveyId ?? null,
      };
    }
    case "task_created": {
      state.history.push(
        `/${state.country.code}/worksites/${state.worksite.id}/tasks/list`
      );

      return {
        ...state,
        templateId: undefined,
        taskCreateModalOpen: false,
      };
    }
    case "modify_task": {
      state.history.push(
        `/${state.country.code}/worksites/${state.worksite.id}/tasks/list/${action.id}`
      );
      return {
        ...state,
        taskCreateModalOpen: true,
      };
    }
    default:
      throw Error("Unknown action: " + action.type);
  }
}

export const initialState = (country, history, worksite, task_id) => ({
  history,
  country,
  filters: {},
  totalPages: 0,
  paginationSkip: 0,
  tasks: [],
  worksite: worksite,
  loading_worksite: true,
  loading_tasks: true,
  error_load: false,
  taskCreateModalOpen: task_id !== undefined,
});
